import React, { useEffect, useState } from 'react';
import Nav from '../../components/ui/Nav';
import { Auth } from 'aws-amplify';
import { FaUser } from 'react-icons/fa';

interface HeaderProps {
  onLogout: () => void;
  checkCurrentUser: () => Promise<void>;
}

const Header: React.FC<HeaderProps> = ({ onLogout, checkCurrentUser }) => {
  const [username, setUsername] = useState('');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        setUsername(user.username);
      } catch (error) {
        console.error(error);
      }
    };

    fetchUser();
  }, []);

  const headerStyle = import.meta.env.VITE_ENV_VERSION !== 'prod' ? '#111827' : '#00B0B9';
  //    process.env.REACT_APP_ENV_VERSION !== "prod" ? "#00B0B9" : "#111827";

  const appName =
    import.meta.env.VITE_ENV_VERSION !== 'prod'
      ? `VRL Dashboard - ${import.meta.env.VITE_ENV_VERSION}`
      : 'VRL Dashboard';

  return (
    <div style={{ position: 'fixed', zIndex: 999, top: '0px', width: '100%' }}>
      <header
        className={'p-4 text-white flex justify-between items-center'}
        style={{ backgroundColor: headerStyle }}
        translate="no"
      >
        <div className="text-2xl font-bold ml-10">{appName}</div>
        <div className="flex flex-row">
          <FaUser className="mr-2 mt-1" />
          <div className="mr-2">{username}</div>
          <Nav onLogout={onLogout} checkCurrentUser={checkCurrentUser} />
        </div>
      </header>
    </div>
  );
};

export default Header;
